<template>
  <el-dialog title="订单详情" :visible.sync="dialogVisible" append-to-body width="80%" :fullscreen="device==='mobile'" @close="dialogClose">
    <el-descriptions title="用户信息" size="medium" :column="4" :label-style="{fontWeight:600}">
      <el-descriptions-item label="ID">{{ order.memberId }}</el-descriptions-item>
      <el-descriptions-item label="用户昵称">{{ order.nickName }}</el-descriptions-item>
      <el-descriptions-item label="绑定手机">{{ order.mobile }}</el-descriptions-item>
      <el-descriptions-item label="用户编号">{{ order.shareCode }}</el-descriptions-item>
    </el-descriptions>
    <el-divider />
    <el-descriptions title="订单信息" size="medium" :colon="false" :label-style="{fontWeight:600, width: '70px', margin:0}">
      <el-descriptions-item label="订单号">{{ order.orderNumber }}</el-descriptions-item>
      <el-descriptions-item label="支付单号">{{ order.payNumber }}</el-descriptions-item>
      <el-descriptions-item label="订单状态">{{ order.orderStatusName }}</el-descriptions-item>
      <el-descriptions-item label="下单时间">{{ order.orderTime }}</el-descriptions-item>
      <el-descriptions-item label="配送方式">{{ order.deliveryMethodName }}</el-descriptions-item>
      <el-descriptions-item label="发货时间">{{ order.logisticsTime }}</el-descriptions-item>
      <el-descriptions-item label="商品总数">{{ order.orderCount }}</el-descriptions-item>
      <el-descriptions-item label="商品总价">{{ order.orderPrice }}</el-descriptions-item>
      <el-descriptions-item label="支付方式">{{ paymentChannel[order.payChannel] }}</el-descriptions-item>
      <el-descriptions-item label="现金">{{ `${[75000,77000].includes(order.orderType) ? order.orderPrice : '0.00'}` }}</el-descriptions-item>
      <el-descriptions-item label="积分">{{ order.orderPoint }}</el-descriptions-item>
      <el-descriptions-item label="券">{{ order.orderCoupon }}</el-descriptions-item>
      <el-descriptions-item v-if="order.orderType !== 77000" label="供应商" :span="2">{{ order.supplierName }}</el-descriptions-item>
      <el-descriptions-item label="惊喜值">{{ order.surpriseValue }}</el-descriptions-item>
    </el-descriptions>
    <el-divider />
    <el-descriptions title="商品信息" size="medium" :label-style="{fontWeight:600}">
      <template v-for="(item, index) in order.products">
        <el-descriptions-item v-if="true" :key="`name-${index}`" label="商品名称" :span="2">{{ item.goodsName }}</el-descriptions-item>
        <el-descriptions-item v-if="true" :key="`count-${index}`" label="数量">{{ item.skuCount }}</el-descriptions-item>
      </template>
    </el-descriptions>
    <template v-if="order.deliveryMethod === 2">
      <el-divider />
      <el-descriptions title="收货信息" size="medium" :column="2" :label-style="{fontWeight:600}">
        <el-descriptions-item label="收件人">{{ order.consigneeName }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ order.consigneeMobile }}</el-descriptions-item>
        <el-descriptions-item label="收货地址">{{ `${order.consigneeRegion}${order.consigneeAddress}` }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <template v-if="order.orderType === 77000">
      <el-divider />
      <el-descriptions title="商家信息" size="medium" :column="2" :label-style="{fontWeight:600}">
        <el-descriptions-item label="商家名称">{{ order.consigneeName }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ order.consigneeMobile }}</el-descriptions-item>
        <el-descriptions-item label="商家地址">{{ `${order.consigneeRegion}${order.consigneeAddress}` }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <template v-if="order.orderStatus > 21 && order.orderType !== 77000">
      <el-divider />
      <el-descriptions title="物流信息" size="medium" :column="2" :label-style="{fontWeight:600}">
        <el-descriptions-item label="快递公司">{{ order.logisticsName }}</el-descriptions-item>
        <el-descriptions-item label="快递单号">{{ order.logisticsNumber }}</el-descriptions-item>
      </el-descriptions>
    </template>

    <template v-slot:footer>
      <el-button type="primary" @click="dialogClose">关　闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderDetail',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      paymentChannel: ['', '钱包支付', '微信支付', '支付宝支付']
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-divider.el-divider--horizontal {
    margin: 14px 0;
  }
</style>
